export default "__VITE_ASSET__FdF_fR_3__"